export default function qualifyLink(linkUrl, origin) {
    if (!linkUrl)
        return '';

    let uri = (linkUrl.startsWith('http') || linkUrl.startsWith('tel:')) ? linkUrl : `${origin || window.location.origin}${linkUrl}`;

    return uri;
}